<template>
  <div class="modal-wrap">
    <el-dialog
      title="批量添加标题"
      :visible.sync="dialogVisible"
      @closed="handleClose"
      width="750px"
    >
      <el-input
        type="textarea"
        :rows="10"
        placeholder="每行一个标题，每个标题5-30个字，敲击回车换行"
        v-model="titleText"
      >
      </el-input>
      <span class="tip-text"
        >提示：最多支持输入{{ curLength }}行，{{
          curLength
        }}行以后自动截断</span
      >
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="addConfirm">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "AddModal",
  data() {
    return {
      dialogVisible: false,
      titleText: "",
      curLength: 10, //当前可以添加的标题数
    };
  },
  methods: {
    showModal(num) {
      this.curLength = 10 - num;
      this.dialogVisible = true;
    },
    handleClose() {
      this.titleText = "";
    },
    addConfirm() {
      let arr = this.titleText.split("\n").filter((item) => item.trim());
      if (arr.length > 0) {
        let res = arr.slice(0, this.curLength);
        this.$emit("selectFinish", res);
        this.dialogVisible = false;
      } else {
        this.$message({
          message: "请输入标题",
          type: "warning",
        });
      }
    },
  },
};
</script>

<style lang='less' scoped>
.tip-text {
  display: inline-block;
  margin-top: 6px;
  color: #999;
}
</style>